<div class="select activator">
  <div class="select-value">
    <span class="fraction" *ngIf="(value || value === 0) && !multiCharFractions">{{ value | size }}</span>
    <span class="fraction" *ngIf="(value || value === 0) && multiCharFractions">{{ value | size:'multichar' }}</span>
    <span class="placeholder" *ngIf="!value && value !== 0" [innerHtml]="placeholder ? placeholder : '&nbsp;'"></span>
  </div>
  <div class="select-arrow-wrapper">
    <div class="select-arrow"></div>
  </div>
</div>

<ng-container *ngIf="loaded">
  <mbnm-size-select (onClose)="activated = false"
                    #sizeSelect [range]="range" [extraOptions]="extraOptions" [(ngModel)]="value">
  </mbnm-size-select>
</ng-container>
